import { takeLatest, call } from 'redux-saga/effects'
import * as fromActions from '../../actions/enrols.action'
import updateSynchronousCourse, {
  SynchronousCourseEnrolBody,
} from 'api/administration/applications/updateSynchronousCourseEnrol'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { ActionWithPayload } from 'helpers/redux-actions.helper'

async function updateEnrol(data: SynchronousCourseEnrolBody) {
  return updateSynchronousCourse(data)
}

const pattern = fromActions.ENROL_ADMIN_SYNCHRONOUS_COURSE_ENROL_EDIT

export type EditSynchronousCourseAction = ActionWithPayload<
  typeof pattern,
  fromActions.EditSynchronousCourseEnrolPayload
>

function* editSynchronousCourseEnrolEffectSaga(
  action: EditSynchronousCourseAction
) {
  const { data, onSuccess, onError } = action.payload
  try {
    yield call(updateEnrol, data)
    onSuccess()
  } catch (error) {
    onError?.()
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* editSynchronousCourseEnrolWatcherSaga() {
  yield takeLatest(pattern, editSynchronousCourseEnrolEffectSaga)
}
